module.exports = __webpack_public_path__ + "img/loginmainicon.07e9037b.svg";